import React, {Component} from 'react';
import axios from "axios";
import NavigateButton from "../modules/NavigateButton";


import en from "../../../locales/en/translation.json";
import fr from '../../../locales/fr/translation.json';

import inst from "../../../assets/logos/instant_3.svg";
import acheter from "../../../assets/logos/bouton_acheter.svg";
import up from "../../../assets/logos/fleche_up.svg";
import down from "../../../assets/logos/fleche_rouge.svg";

export default class VideoInstant extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: this.props.user,
            video: null,
            trad: en,
            lang: "en",
            instant: null,
        }
    }

    async componentDidMount() {
        document.title = "Infos du NFT | Wonderplace";
        document.querySelector("body").classList.add("pageother");
        document.querySelector(".footerGlobal").classList.add("videoinstant");
        document.querySelector(".content").classList.add("content_video");

        if (localStorage.getItem('storageType')) {
            if (localStorage.getItem('message')) {
                let message = localStorage.getItem('message');
                message = message.split(':');
                this.setState({
                    flashMessage: message[1],
                    typeFlash: message[0],
                }, () => {
                    localStorage.removeItem('message');
                    setTimeout(() => {
                        this.setState({
                            flashMessage: "",
                            typeFlash: "",
                        });
                    }, 2000);
                })
            }
            let user = localStorage.getItem('user');
            if (user !== null) {
                let userConnect = JSON.parse(user);
                if (JSON.parse(localStorage.getItem("user"))) {
                    this.setState({
                        user: JSON.parse(localStorage.getItem("user")),
                    }, () => {
                        let lang = this.state.user.user.language;
                        if (lang === "fr") {
                            this.setState({lang: "fr", trad: fr});
                        }
                    });
                }
                await this.setState({
                    user: userConnect,
                })
            } else {
                location.assign('/');
            }
            let token = location.pathname.split('/');
            let url = import.meta.env.VITE_BACKEND_URL + '/instant/getIntantNft';
            axios.post(url, {
                    token: token[2],
                    id: token[3]
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + this.state.user.token
                    }
                }).then(response => {
                console.log(response.data);
                this.setState({video: response.data, instant: token[3]});
            }).catch(error => {
                console.log('Config:', error.config);
            })
        }
    }

    formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
    }

    render() {
        return (
            <>
                <div className="compteGeneralGlobal videoInstant">
                    <div className="compteHeader">
                        <NavigateButton trad={this.state.trad}/>
                        <h1>{this.state.trad.infosDuNft}</h1>
                    </div>
                    {
                        this.state.video !== null &&
                        <div className="center">
                            <div className="left">
                                <div className="video_img">
                                    <img src={`${import.meta.env.VITE_BACKEND_URL_IMG}${this.state.video.miniature}`}
                                         alt=""/>
                                    <div className="round_background">
                                        <img src={inst} alt=""/>
                                    </div>
                                    <div className="time">
                                        {
                                            this.state.video.nft.map((value, index) => (
                                                value.startTime === this.state.instant &&
                                                <p key={index}>{this.formatTime(value.startTime)}</p>
                                            ))
                                        }
                                    </div>
                                </div>
                                <div className="creator">
                                    <div className="left_creator">
                                        <img
                                            src={`${import.meta.env.VITE_BACKEND_URL_IMG}${this.state.video.perso.avatar}`}
                                            alt=""/>
                                    </div>
                                    <div className="right_creator">
                                        <p>{this.state.video.creator.name}</p>
                                        <p>{this.state.video.creator.nom_artiste}</p>
                                    </div>
                                </div>
                                <div className="block_creator">
                                    <p>{this.state.trad.creator}</p>
                                    <p>{this.state.video.perso.biographie}</p>
                                </div>
                                <div className="owner_message">
                                    {
                                        this.state.video.nft.map((value, index) => (
                                            value.startTime === this.state.instant &&
                                            <p key={index}>Owner : {value.owner.name} <span>{value.message}</span></p>
                                        ))
                                    }
                                </div>
                            </div>
                            <div className="right">
                                <h2>Prix actuel de l’instant</h2>
                                <div className="block_price">
                                    <div className="price">
                                        <div className="left">
                                            <p>26 € <br/><span>Valeur en euro</span></p>
                                        </div>
                                        <div className="right">
                                            <p>0,025 MATIC <br/><span>Valeur crypto</span></p>
                                        </div>
                                    </div>
                                    <div className="block_button">
                                        <button className="btn_blue_btn">Acheter</button>
                                        <button className="btn_blue_btn">Proposition de rachat</button>
                                    </div>
                                </div>
                                <h2>Historique des possesseurs et des messages</h2>
                                <div className="table_price">
                                    <div className="table_price_header">
                                        <div className="td">Prix €</div>
                                        <div className="td">Prix MATIC</div>
                                        <div className="td">Possesseurs</div>
                                        <div className="td">Messages</div>
                                    </div>
                                    <div className="table_price_body">
                                        <div className="tb">33€</div>
                                        <div className="tb">0,023 MATIC</div>
                                        <div className="tb">@tomblissard</div>
                                        <div className="tb">Super cette découverte !</div>
                                    </div>
                                    <div className="table_price_body">
                                        <div className="tb">33€</div>
                                        <div className="tb">0,023 MATIC</div>
                                        <div className="tb">@tomblissard</div>
                                        <div className="tb">Super cette découverte !</div>
                                    </div>
                                    <div className="table_price_body">
                                        <div className="tb">33€</div>
                                        <div className="tb">0,023 MATIC</div>
                                        <div className="tb">@tomblissard</div>
                                        <div className="tb">Super cette découverte !</div>
                                    </div>
                                </div>
                                <h2>Les offres de rachat en cours</h2>
                                <div className="table_price">
                                    <div className="table_price_header">
                                        <div className="td">Prix €</div>
                                        <div className="td">Prix MATIC</div>
                                        <div className="td">De la part de</div>
                                        <div className="td">Expiration de l’offre</div>
                                    </div>
                                    <div className="table_price_body">
                                        <div className="tb">33€</div>
                                        <div className="tb">0,023 MATIC</div>
                                        <div className="tb">@tomblissard</div>
                                        <div className="tb">10 jours</div>
                                    </div>
                                    <div className="table_price_body">
                                        <div className="tb">33€</div>
                                        <div className="tb">0,023 MATIC</div>
                                        <div className="tb">@tomblissard</div>
                                        <div className="tb">9 jours</div>
                                    </div>
                                    <div className="table_price_body">
                                        <div className="tb">33€</div>
                                        <div className="tb">0,023 MATIC</div>
                                        <div className="tb">@tomblissard</div>
                                        <div className="tb">expiré</div>
                                    </div>
                                </div>
                                <h2>Activités passées de l’instant</h2>
                                <div className="table_price">
                                    <div className="table_price_header">
                                        <div className="td six">Évènements</div>
                                        <div className="td six">Prix €</div>
                                        <div className="td six">Prix MATIC</div>
                                        <div className="td six">De la part de</div>
                                        <div className="td six">Pour</div>
                                        <div className="td six">Date</div>
                                    </div>
                                    <div className="table_price_body">
                                        <div className="tb six">Vente</div>
                                        <div className="tb six">33€</div>
                                        <div className="tb six">0,023 MATIC</div>
                                        <div className="tb six">@tomblissard</div>
                                        <div className="tb six">@esther_spt</div>
                                        <div className="tb six">24/03/2023</div>
                                    </div>
                                    <div className="table_price_body">
                                        <div className="tb six">Vente</div>
                                        <div className="tb six">33€</div>
                                        <div className="tb six">0,023 MATIC</div>
                                        <div className="tb six">@tomblissard</div>
                                        <div className="tb six">@esther_spt</div>
                                        <div className="tb six">24/03/2023</div>
                                    </div>
                                    <div className="table_price_body">
                                        <div className="tb six">Vente</div>
                                        <div className="tb six">33€</div>
                                        <div className="tb six">0,023 MATIC</div>
                                        <div className="tb six">@tomblissard</div>
                                        <div className="tb six">@esther_spt</div>
                                        <div className="tb six">24/03/2023</div>
                                    </div>
                                </div>
                                <h2>Autres instants de la vidéo</h2>
                                <div className="line_video_right">
                                    <div className="block_video">
                                        <div className="image_block">
                                            <img
                                                src={`${import.meta.env.VITE_BACKEND_URL_IMG}${this.state.video.miniature}`}
                                                alt=""/>
                                            <div className="time">
                                                <p>0:05</p>
                                            </div>
                                        </div>
                                        <div className="titre_video">
                                            <div className="left">
                                                <p>nom video</p>
                                                <p>nom creator</p>
                                            </div>
                                            <div className="right">
                                                <img src={acheter} alt=""/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="block_video">
                                        <div className="image_block">
                                            <img
                                                src={`${import.meta.env.VITE_BACKEND_URL_IMG}${this.state.video.miniature}`}
                                                alt=""/>
                                            <div className="time">
                                                <p>0:05</p>
                                            </div>
                                        </div>
                                        <div className="titre_video">
                                            <div className="left">
                                                <p>nom video</p>
                                                <p>nom creator</p>
                                            </div>
                                            <div className="right">
                                                <img src={acheter} alt=""/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="block_video">
                                        <div className="image_block">
                                            <img
                                                src={`${import.meta.env.VITE_BACKEND_URL_IMG}${this.state.video.miniature}`}
                                                alt=""/>
                                            <div className="time">
                                                <p>0:05</p>
                                            </div>
                                        </div>
                                        <div className="titre_video">
                                            <div className="left">
                                                <p>nom video</p>
                                                <p>nom creator</p>
                                            </div>
                                            <div className="right">
                                                <img src={acheter} alt=""/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <h2>Plus d’instants de l’artiste</h2>
                                <div className="line_video_right">
                                    <div className="block_video">
                                        <div className="image_block">
                                            <img
                                                src={`${import.meta.env.VITE_BACKEND_URL_IMG}${this.state.video.miniature}`}
                                                alt=""/>
                                            <div className="time">
                                                <p>0:05</p>
                                            </div>
                                        </div>
                                        <div className="titre_video">
                                            <div className="left">
                                                <p>nom video</p>
                                                <p>nom creator</p>
                                            </div>
                                            <div className="right">
                                                <img src={acheter} alt=""/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="block_video">
                                        <div className="image_block">
                                            <img
                                                src={`${import.meta.env.VITE_BACKEND_URL_IMG}${this.state.video.miniature}`}
                                                alt=""/>
                                            <div className="time">
                                                <p>0:05</p>
                                            </div>
                                        </div>
                                        <div className="titre_video">
                                            <div className="left">
                                                <p>nom video</p>
                                                <p>nom creator</p>
                                            </div>
                                            <div className="right">
                                                <img src={acheter} alt=""/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="block_video">
                                        <div className="image_block">
                                            <img
                                                src={`${import.meta.env.VITE_BACKEND_URL_IMG}${this.state.video.miniature}`}
                                                alt=""/>
                                            <div className="time">
                                                <p>0:05</p>
                                            </div>
                                        </div>
                                        <div className="titre_video">
                                            <div className="left">
                                                <p>nom video</p>
                                                <p>nom creator</p>
                                            </div>
                                            <div className="right">
                                                <img src={acheter} alt=""/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <h2>Instants en hausse</h2>
                                <div className="line_video_right">
                                    <div className="block_video_nft">
                                        <div className="image_block">
                                            <img
                                                src={`${import.meta.env.VITE_BACKEND_URL_IMG}${this.state.video.miniature}`}
                                                alt=""/>
                                            <div className="time">
                                                <p>0:05</p>
                                            </div>
                                        </div>
                                        <div className="titre_video">
                                            <div className="left">
                                                <p>nom video</p>
                                                <p>nom creator</p>
                                            </div>
                                            <div className="right arrow blue">
                                                <p><img src={up} alt=""/> +3</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="block_video_nft">
                                        <div className="image_block">
                                            <img
                                                src={`${import.meta.env.VITE_BACKEND_URL_IMG}${this.state.video.miniature}`}
                                                alt=""/>
                                            <div className="time">
                                                <p>0:05</p>
                                            </div>
                                        </div>
                                        <div className="titre_video">
                                            <div className="left">
                                                <p>nom video</p>
                                                <p>nom creator</p>
                                            </div>
                                            <div className="right arrow blue">
                                                <p><img src={up} alt=""/> +3</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="block_video_nft">
                                        <div className="image_block">
                                            <img
                                                src={`${import.meta.env.VITE_BACKEND_URL_IMG}${this.state.video.miniature}`}
                                                alt=""/>
                                            <div className="time">
                                                <p>0:05</p>
                                            </div>
                                        </div>
                                        <div className="titre_video">
                                            <div className="left">
                                                <p>nom video</p>
                                                <p>nom creator</p>
                                            </div>
                                            <div className="right arrow blue">
                                                <p><img src={up} alt=""/> +3</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <h2>Instants en baisse</h2>
                                <div className="line_video_right">
                                    <div className="block_video_nft">
                                        <div className="image_block">
                                            <img
                                                src={`${import.meta.env.VITE_BACKEND_URL_IMG}${this.state.video.miniature}`}
                                                alt=""/>
                                            <div className="time">
                                                <p>0:05</p>
                                            </div>
                                        </div>
                                        <div className="titre_video">
                                            <div className="left">
                                                <p>nom video</p>
                                                <p>nom creator</p>
                                            </div>
                                            <div className="right arrow red">
                                                <p><img src={down} alt=""/> -3</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="block_video_nft">
                                        <div className="image_block">
                                            <img
                                                src={`${import.meta.env.VITE_BACKEND_URL_IMG}${this.state.video.miniature}`}
                                                alt=""/>
                                            <div className="time">
                                                <p>0:05</p>
                                            </div>
                                        </div>
                                        <div className="titre_video">
                                            <div className="left">
                                                <p>nom video</p>
                                                <p>nom creator</p>
                                            </div>
                                            <div className="right arrow red">
                                                <p><img src={down} alt=""/> -3</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="block_video_nft">
                                        <div className="image_block">
                                            <img
                                                src={`${import.meta.env.VITE_BACKEND_URL_IMG}${this.state.video.miniature}`}
                                                alt=""/>
                                            <div className="time">
                                                <p>0:05</p>
                                            </div>
                                        </div>
                                        <div className="titre_video">
                                            <div className="left">
                                                <p>nom video</p>
                                                <p>nom creator</p>
                                            </div>
                                            <div className="right arrow red">
                                                <p><img src={down} alt=""/> -3</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </>
        )
    }

}
